import { Action } from 'redux';
import type { MonthlyNetSalesReport } from 'model/MonthlyNetSalesReport';

export const MONTHLY_NET_SALES_REPORT_GET_START = 'MONTHLY_NET_SALES_REPORT_GET_START';
export const MONTHLY_NET_SALES_REPORT_GET_SUCCESS = 'MONTHLY_NET_SALES_REPORT_GET_SUCCESS';
export const MONTHLY_NET_SALES_REPORT_GET_ERROR = 'MONTHLY_NET_SALES_REPORT_GET_ERROR';

export type MonthlyNetSalesReportGetStartAction = Action<typeof MONTHLY_NET_SALES_REPORT_GET_START>;

export interface MonthlyNetSalesReportGetSuccessAction extends Action<typeof MONTHLY_NET_SALES_REPORT_GET_SUCCESS> {
    payload: {
        report: MonthlyNetSalesReport;
    };
}

export type MonthlyNetSalesReportGetErrorAction = Action<typeof MONTHLY_NET_SALES_REPORT_GET_ERROR>;

export type MonthlyNetSalesReportAction =
    | MonthlyNetSalesReportGetStartAction
    | MonthlyNetSalesReportGetSuccessAction
    | MonthlyNetSalesReportGetErrorAction;
